import React from "react"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"

import BlockBodySection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySection"
import BlockBodySectionRequiredCondition, { ContinueConditionIcon } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionRequiredCondition"
import BlockBodySectionHandle from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionHandle"

import { getConditionRuleByValidationSlug } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockRule"

type ContactHasNoResponsibleUserConditionSectionProps = {
	nextChatBotFlowBlockRules: ChatBotFlowBlockRule[]
}

const ContactHasNoResponsibleUserConditionSection: React.FC<ContactHasNoResponsibleUserConditionSectionProps> = (props) => {
	const {
		nextChatBotFlowBlockRules
	} = props

	const contactHasNoResponsibleUserRule = getConditionRuleByValidationSlug("rd-station-contact-has-no-responsible-user", nextChatBotFlowBlockRules)

	if (!contactHasNoResponsibleUserRule) {
		return null
	}

	return (
		<BlockBodySection>
			<BlockBodySectionHandle
				chatBotFlowBlockRule={contactHasNoResponsibleUserRule}
			>
				<BlockBodySectionRequiredCondition
					text="Se o contato não possuir atendente responsável"
					icon={<ContinueConditionIcon />}
				/>
			</BlockBodySectionHandle>
		</BlockBodySection>
	)
}

export default ContactHasNoResponsibleUserConditionSection
